export const slugify = (s = "") =>
  s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const unslug = (s = "") =>
  s.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
